import { AbstractControl } from '@angular/forms';

export function uniqueCharactersValidator(count) {
    return (control: AbstractControl) => {
        var uchar = {}
        var countOfUniqueChar = 0;
        var value = control.value;
        if(value?.length > 0){
            for (var i = 0; i < value.length; i++) {
                if (uchar[value[i]] != undefined) {
                    uchar[value[i]] = uchar[value[i]] + 1;
                } else {
                    uchar[value[i]] = 1;
                }
            }
            for(let i in uchar){
                if(uchar[i] == 1){
                    countOfUniqueChar++
                }
            }
            if(countOfUniqueChar < count){
                return { uniqueChar: true};
            }
        }
    }
}